var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isBusy,
          expression: "isBusy",
        },
      ],
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "element-loading-spinner": "el-icon-loading",
            "label-width": "170px",
          },
        },
        [
          _c(
            "el-collapse",
            {
              attrs: { accordion: "" },
              model: {
                value: _vm.collapse,
                callback: function ($$v) {
                  _vm.collapse = $$v
                },
                expression: "collapse",
              },
            },
            [
              _c(
                "el-collapse-item",
                {
                  attrs: {
                    title: "Sender and Receiver Information",
                    name: "info",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "div",
                          { staticClass: "w-100 text-left mb-3" },
                          [
                            _c("p", [
                              _c("b", [_vm._v("To:")]),
                              _vm._v(
                                " " + _vm._s(_vm.getEmailAddressPresentation)
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "outgoing_number_id",
                                  label: "Outgoing Number",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "w-100",
                                    attrs: { filterable: "" },
                                    model: {
                                      value: _vm.form.outgoing_number_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "outgoing_number_id",
                                          $$v
                                        )
                                      },
                                      expression: "form.outgoing_number_id",
                                    },
                                  },
                                  _vm._l(
                                    _vm.outgoingNumberList,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _vm.contactExist
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "alert alert-success mb-3 text-center",
                                  attrs: { role: "alert" },
                                },
                                [
                                  _vm._v(
                                    "\n              The contact already exist.\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "w-100 text-left font-weight-bold mb-3 text-uppercase",
                            },
                            [_c("p", [_vm._v("From:")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "ID", prop: "id" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.form.id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "id", $$v)
                                  },
                                  expression: "form.id",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "First Name",
                                prop: "first_name",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: this.contactExist },
                                model: {
                                  value: _vm.form.first_name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "first_name", $$v)
                                  },
                                  expression: "form.first_name",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "Last Name", prop: "last_name" },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: this.contactExist },
                                model: {
                                  value: _vm.form.last_name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "last_name", $$v)
                                  },
                                  expression: "form.last_name",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Email", prop: "email" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.form.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "email", $$v)
                                  },
                                  expression: "form.email",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Filemaker ID",
                                prop: "filemaker_id",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: this.contactExist },
                                model: {
                                  value: _vm.form.filemaker_id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "filemaker_id", $$v)
                                  },
                                  expression: "form.filemaker_id",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-collapse-item",
                { attrs: { title: "Subject and Message", name: "message" } },
                [
                  _c(
                    "div",
                    { staticClass: "w-100 text-left mb-3 text-uppercase" },
                    [
                      _c("p", [
                        _c("b", [_vm._v("Subject:")]),
                        _vm._v(" " + _vm._s(_vm.getSubject)),
                      ]),
                      _vm._v(" "),
                      _c("p", [_c("b", [_vm._v("Message:")])]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.collapse === "message"
                    ? _c("iframe-loader", { attrs: { url: _vm.previewUrl } })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-purple px-4 mt-3", on: { click: _vm.store } },
        [_vm._v("Approve")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }